"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _material = require("@mui/material");

var _SideNav = _interopRequireDefault(require("./Back/SideNav.Back"));

var _SideNav2 = _interopRequireDefault(require("./Item/SideNav.Item"));

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["children", "ListProps"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var StyledPaper = (0, _material.styled)(_material.Paper)(function (_ref) {
  var theme = _ref.theme;
  return {
    flex: "0 0 auto",
    overflowY: "auto",
    paddingBottom: theme.spacing(8),
    paddingTop: theme.spacing(5),
    width: theme.widths.sideNav
  };
});

var SideNav = function SideNav(_ref2) {
  var children = _ref2.children,
      ListProps = _ref2.ListProps,
      props = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledPaper, _objectSpread(_objectSpread({
    component: "nav",
    square: true
  }, props), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.List, _objectSpread(_objectSpread({}, ListProps), {}, {
      children: children
    }))
  }));
};

SideNav.Back = _SideNav.default;
SideNav.Item = _SideNav2.default;
var _default = SideNav;
exports.default = _default;